// Central config — official links for The Velvet Testament.
export const SOCIALS = {
  spotify: "https://open.spotify.com/artist/5Qbi2VNAV8LUc1RSHbYQ84",
  instagram: "https://www.instagram.com/thevelvettestament/",
  facebook: "https://www.facebook.com/thevelvettestament",
};

export const MANAGEMENT_EMAIL = "thevelvettestament@gmail.com";

// Debut single + first album (no invented dates)
export const LATEST_SINGLE = {
  title: "When The House Goes Quiet",
  feat: "Ellis Marrow",
  status: "Available now",
  album: "Rooms That Learned to Echo",
};

const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/b5230c257e8fa3ec93aacc81f7bb60438b9cefe68b31a3e2e66b36392be36fb3.jpeg",
  studio: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/e5fdde985a59a89bfd4d1a2c4d415f92259b57401abf026db9daf7a8bf8004b0.jpeg",
  release: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/8740ab8d543039bed57cb79e651ad1099977cf26b92716f598cb7fc0a9c5e97f.jpeg",
  lantern: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/bba638d27a7b49baefa3df44d474db231a8c13f8504fb4fc101da45edbf2d670.jpeg",
  ellis: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/2540ebbcb026d6d6e6403624fa3c953702eda65575d40f15858fc40645d72caf.jpeg",
  inez: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/a30c84a70443939d0b2d471cd35dd07a572a2ca6b3b905a97e96fd2b7c0c1a00.jpeg",
  silas: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/0db8eacbb91bef98a00304af0f80afd6ebaa3685110ed92de4901cb7403a0e7f.jpeg",
  ruby: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/4ca7741db6c418e05272d069272207fa7eae3e109860952599472ee053fa96d3.jpeg",
  marcus: "https://static.prod-images.emergentagent.com/jobs/3c52fc18-9107-47e9-bb0b-47a93cd2f940/images/b03805701852637bdcf138d865b41160db551a9fc48be26acd637d1e3a63a84e.jpeg",
};

export const IMAGES = IMG;

export const ARTISTS = [
  {
    id: "ellis-marrow",
    name: "Ellis Marrow",
    handle: "The First Voice",
    era: "Baritone Soul",
    image: IMG.ellis,
    identity: "Warm, weathered baritone · memory, regret & second chances",
    span: "md:col-span-7 md:row-span-2",
    bio: "Ellis Marrow carries a warm, weathered baritone shaped by memory, regret and second chances. His songs live in empty rooms, old kitchens, motel rooms, late-night roads and the places people leave behind.",
    story: "The first recurring voice of The Velvet Testament — the one who keeps returning to the rooms he can't forget.",
    tracks: [
      "When The House Goes Quiet",
      "Back When the Kitchen Danced",
      "Sunday Shoes",
      "Room 214",
      "Leave the Porch Light Burning",
      "The Piano in the Back Room",
      "I Learned Too Late How to Stay",
    ],
  },
  {
    id: "inez-bellamy",
    name: "Inez Bellamy",
    handle: "Her Own Voice",
    era: "Contralto Soul",
    image: IMG.inez,
    identity: "Deep contralto · dignity, independence & hard-earned grace",
    span: "md:col-span-5",
    bio: "Inez Bellamy is a deep contralto voice of dignity, independence and hard-earned grace. Her songs explore reclaimed space, self-respect and the moment a woman finally chooses her own voice.",
    story: "A recurring voice of The Velvet Testament — singing the moment a woman finally chooses herself.",
    tracks: [
      "I Sleep Diagonal Now",
      "Midnight Looks Good on Me",
      "The First Note Was Mine",
      "No Me Esperes Despierto",
    ],
  },
  {
    id: "silas-rowe",
    name: "Silas Rowe",
    handle: "The Gospel Fire",
    era: "Southern Soul",
    image: IMG.silas,
    identity: "Urgent Southern soul · gospel-rooted grit",
    span: "md:col-span-4",
    bio: "Silas Rowe brings fire to The Velvet Testament — urgent Southern soul, gospel-rooted grit and the sound of a man running out of places to hide.",
    story: "A recurring voice of The Velvet Testament — all fire and gospel and nowhere left to hide.",
    tracks: [
      "You Can't Love Me Halfway",
      "I Should've Left Before I Loved You",
      "A Man Can Run Out of Road",
    ],
  },
  {
    id: "ruby-calder",
    name: "Ruby Calder",
    handle: "Heartbreak in Motion",
    era: "Rhythmic Soul",
    image: IMG.ruby,
    identity: "Rhythmic soul · gospel attack, warmth & sharp wit",
    span: "md:col-span-4",
    bio: "Ruby Calder turns heartbreak into movement. Her voice combines rhythmic soul energy, gospel attack, warmth and sharp emotional wit.",
    story: "A recurring voice of The Velvet Testament — turning every heartbreak into rhythm.",
    tracks: [
      "He Left With the Lights Still On",
      "Don't Come Back Beautiful",
      "Everybody Knew But Me",
    ],
  },
  {
    id: "marcus-vale",
    name: "Marcus Vale",
    handle: "The Late-Night Voice",
    era: "Quiet-Storm Soul",
    image: IMG.marcus,
    identity: "Quiet-storm soul · warm baritone & elegant phrasing",
    span: "md:col-span-4",
    bio: "Marcus Vale lives in the late-night side of soul: warm baritone, elegant phrasing, quiet-storm intimacy and adult romantic storytelling.",
    story: "A recurring voice of The Velvet Testament — keeping the lamp on till the last light in the window.",
    tracks: [
      "Don't Turn the Lamp Off Yet",
      "She Left Her Perfume in the Car",
      "I Saw You Before You Saw Me",
      "The Last Light in Your Window",
    ],
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "A Timeless Universe",
    body: "The Velvet Testament is not a band. It is a timeless soul universe built around original stories and recurring voices — no trends, no committees. Only music made to be lived in.",
  },
  {
    no: "02",
    title: "Original Stories",
    body: "Each release moves a single, unfolding story forward: love found in quiet rooms, self-respect hard-won, cities that hum at 3 a.m. The songs speak to one another so the catalogue reads like a novel you can feel.",
  },
  {
    no: "03",
    title: "Recurring Voices",
    body: "Five voices carry the Testament forward, appearing and reappearing across songs like characters in a long, tender saga. Every voice leaves a testament.",
  },
];
